import React from 'react';
import { X } from 'lucide-react';

export function SynopsisModal({ show, onClose, title, overview, genres, rating, releaseDate }) {
  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="bg-bg-secondary border border-white/20 rounded-lg p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-white/10 rounded-full transition-colors"
        >
          <X className="w-5 h-5 text-white" />
        </button>

        {/* Title */}
        <h2 className="text-3xl font-bebas text-white mb-4 pr-12">
          {title}
        </h2>

        {/* Info line */}
        <div className="flex items-center gap-4 mb-4 flex-wrap">
          {rating && rating !== 'N/A' && (
            <div className="flex items-center gap-1">
              <span className="text-yellow-400">⭐</span>
              <span className="text-white font-work font-semibold">{rating}/10</span>
            </div>
          )}
          
          {releaseDate && (
            <span className="text-text-secondary text-sm">
              {new Date(releaseDate).getFullYear()}
            </span>
          )}
          
          {genres && genres.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {genres.slice(0, 4).map((genre, i) => (
                <span 
                  key={i} 
                  className="text-xs px-3 py-1 bg-netflix-red/20 text-netflix-red rounded-full border border-netflix-red/40"
                >
                  {genre}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Synopsis */}
        <div className="mt-4">
          <h3 className="text-white font-work font-semibold mb-2 uppercase text-sm tracking-wider">
            Synopsis
          </h3>
          <p className="text-text-secondary font-inter leading-relaxed">
            {overview || 'Aucun synopsis disponible pour ce film.'}
          </p>
        </div>
      </div>
    </div>
  );
}
